// Layout.js
import React from 'react';
import { HashRouter } from 'react-router-dom';
import SideNav from '../../components/SideNav';
import classNames from "classnames";
import AppRoute from '../routes/AppRoute';
import { useSelector } from 'react-redux';
import ToolBar from '../../components/ToolBar';
import { loginSelector } from '../../redux/slices/loginSlice';
import { dashboardSelector } from '../../redux/slices/dashboardSlice';

const Layout = () => {
  const loginStore = useSelector(loginSelector)
  const dashboardState = useSelector(dashboardSelector);
  return (
    <HashRouter>
      <div>
        {
          loginStore.status === 'authenticated'
            ?
            <>
            <SideNav />
              <div className={classNames("content", { "is-open":  dashboardState.isOpenSideMenu })}>
                <ToolBar/>
                <AppRoute />
              </div>
              </>
            :<AppRoute />
        }
      </div>
      </HashRouter>
  );
};

export default Layout;
